import { useEffect } from 'react';
// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// redux
import { useSelector, useDispatch } from 'redux/store';
import { scanCurrent } from 'redux/slices/questionnaire';
// components
import ThemeSettings from './components/settings';
import ScrollToTop from './components/ScrollToTop';
import { ProgressBarStyle } from './components/ProgressBar';
import MotionLazyContainer from './components/animate/MotionLazyContainer';
import NotistackProvider from './components/NotistackProvider';
import { useLocation } from 'react-router-dom';
import { PATH_PAGE } from 'routes/paths';
// ----------------------------------------------------------------------

export default function App() {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { profileInfo } = useSelector((state) => state.profile);

  useEffect(() => {
    if (
      profileInfo.id &&
      !pathname.includes(PATH_PAGE.invite) &&
      !pathname.includes(PATH_PAGE.login) &&
      !pathname.includes(PATH_PAGE.signup)
    )
      dispatch(scanCurrent(false, profileInfo.isStarterPlan));
  }, [dispatch, profileInfo.id, profileInfo.isStarterPlan]);

  return (
    <MotionLazyContainer>
      <ThemeProvider>
        <ThemeSettings>
          <NotistackProvider>
            <ProgressBarStyle />
            <ScrollToTop />
            <Router />
          </NotistackProvider>
        </ThemeSettings>
      </ThemeProvider>
    </MotionLazyContainer>
  );
}
